module.exports = __webpack_public_path__ + "static/img/banner@2x.80ff43d9.jpg";